import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/lib/auth";
import PublicLayout from "@/components/PublicLayout";
import AdminLayout from "@/components/AdminLayout";
import LandingPage from "@/pages/LandingPage";
import LegalPage from "@/pages/LegalPage";
import QRRedirect from "@/pages/QRRedirect";
import GoRedirect from "@/pages/GoRedirect";
import Login from "@/pages/admin/Login";
import ForgotPassword from "@/pages/admin/ForgotPassword";
import ResetPassword from "@/pages/admin/ResetPassword";
import Dashboard from "@/pages/admin/Dashboard";
import ContentEditor from "@/pages/admin/ContentEditor";
import MediaManager from "@/pages/admin/MediaManager";
import LegalEditor from "@/pages/admin/LegalEditor";
import Settings from "@/pages/admin/Settings";
import SEOEditor from "@/pages/admin/SEOEditor";
import UserManager from "@/pages/admin/UserManager";
import QRCodePage from "@/pages/admin/QRCodePage";
import HeroCombinations from "@/pages/admin/HeroCombinations";
import Backup from "@/pages/admin/Backup";
import VersionPage from "@/pages/admin/VersionPage";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<PublicLayout />}>
            <Route path="/" element={<LandingPage />} />
            <Route path="/impressum" element={<LegalPage type="impressum" />} />
            <Route path="/datenschutz" element={<LegalPage type="datenschutz" />} />
          </Route>
          <Route path="/qr" element={<QRRedirect />} />
          <Route path="/go" element={<GoRedirect />} />
          <Route path="/admin/login" element={<Login />} />
          <Route path="/admin/forgot-password" element={<ForgotPassword />} />
          <Route path="/admin/reset-password" element={<ResetPassword />} />
          <Route element={<AdminLayout />}>
            <Route path="/admin/dashboard" element={<Dashboard />} />
            <Route path="/admin/content" element={<ContentEditor />} />
            <Route path="/admin/media" element={<MediaManager />} />
            <Route path="/admin/legal" element={<LegalEditor />} />
            <Route path="/admin/settings" element={<Settings />} />
            <Route path="/admin/seo" element={<SEOEditor />} />
            <Route path="/admin/users" element={<UserManager />} />
            <Route path="/admin/qrcode" element={<QRCodePage />} />
            <Route path="/admin/hero-combinations" element={<HeroCombinations />} />
            <Route path="/admin/backup" element={<Backup />} />
            <Route path="/admin/version" element={<VersionPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </AuthProvider>
  );
}

export default App;
